import type { MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';

type Result = ModelHookResult<{
	amountChoices: readonly number[];
	ref: MutableRefObject<HTMLDivElement | null>;
}>;

export function useImpressionAmountSelector(): Result {
	const {
		data: { amountChoices },
	} = usePromotePageData();

	const [{ validationErrors }] = usePromotePageState();

	const ref = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (ref.current && validationErrors?.amount) ref.current.scrollIntoView();
	}, [validationErrors?.amount, ref]);

	return {
		data: {
			amountChoices,
			ref,
		},
	};
}
